import QuestionBreakdownReport from './QuestionsBreakdownReport';
import { useSearchParams } from 'react-router-dom';
import { useGetStudentSessionReportMutation } from '../../../../../../features/authentication/reportApiSlice';
import { useReportContext } from '../../../../../reports/components/reportContext';

const StudentSessionReport = () => {
  const [searchParams] = useSearchParams();
  const [getStudentSessionsReport] = useGetStudentSessionReportMutation();
  const reportContext = useReportContext();
  var studentToIncludeTab = parseInt(searchParams.get('studentsToInclude'));
  const isTeacherReport = !isNaN(parseInt(studentToIncludeTab, 10));

  const getReportTitle = () =>{
    if(reportContext)
    {
      if(reportContext.isAssessment)
        return 'Student- Single Assessment Report';
      else
        return 'Student- Single Assignment Report';
    }
    else
      return 'Student Session Report';
  };

  var headerOptions = {
    reportTitle: getReportTitle(),
    showClassDropdown: false,
    showTeacherName: false,
    showStudentName: true,
    showClassName: false,
    isAllStudentReport: false,
    showRetryInfo: true,
    showTotalRow: false,
    showReportType: true,
    reportType: 'Session'
  };

  return (
    <QuestionBreakdownReport
      includeRetakeData={false}
      studentId={searchParams.get('studentId')}
      reportTitle={getReportTitle()}
      exportFileName='StudentSessionReport'
      reportDataEndpoint={getStudentSessionsReport}
      individualResultsOrientation='vertical'
      headerOptions={headerOptions}
      isTeacherReport={isTeacherReport}
      studentToIncludeTab={studentToIncludeTab}
      goBackOnError={true}
      />
  );

};

export default StudentSessionReport;